import _typeof from "/app/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { cleanErrors, noErrors } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { fetchAddressSuggestions, parseAddressFromMapbox, getCurrentPositionAddress } from "@/js/mapbox/geocoding.js";
export default {
  name: "Address",
  props: ["disabled", "baseModel", "readOnly", "listCountries", "listStates", "disabledCountry", "disabledState", "countryTooltipMessage", "stateTooltipMessage", "typeDisplayError", "showDeliveryInstructions"],
  data: function data() {
    return {
      form: {
        valid: false
      },
      errorLabels: {
        street: "",
        city: "",
        state: "",
        country: ""
      },
      errorMessages: {
        mandatory: "This field is required"
      },
      displayedListStates: [],
      formRules: formRules,
      addressSuggestions: [],
      loadingAddressSuggestions: false,
      searchInput: null,
      debounceTimer: null,
      loadingCurrentLocation: false
    };
  },
  computed: {
    isEmpty: function isEmpty() {
      var _this$baseModel$state, _this$baseModel$count;
      return !this.baseModel.street && !this.baseModel.zip && !this.baseModel.city && !((_this$baseModel$state = this.baseModel.state) !== null && _this$baseModel$state !== void 0 && _this$baseModel$state.state_label) && !((_this$baseModel$count = this.baseModel.country) !== null && _this$baseModel$count !== void 0 && _this$baseModel$count.printable_name);
    },
    valid: function valid() {
      return this.typeDisplayError === "rules" ? this.form.valid : this.validateForm();
    }
  },
  created: function created() {
    if (this.baseModel.country) this.generateStatesList();
  },
  methods: {
    validateForm: function validateForm() {
      var _this$baseModel$count2;
      this.errorLabels = cleanErrors(this.errorLabels);
      if (!this.baseModel.street) {
        this.errorLabels.street = this.errorMessages.mandatory;
      }
      if (!this.baseModel.city) {
        this.errorLabels.city = this.errorMessages.mandatory;
      }
      if (!((_this$baseModel$count2 = this.baseModel.country) !== null && _this$baseModel$count2 !== void 0 && _this$baseModel$count2.id_country)) {
        this.errorLabels.country = this.errorMessages.mandatory;
      }
      if (this.displayedListStates.length > 0 && !this.baseModel.state.id_state) {
        this.errorLabels.state = this.errorMessages.mandatory;
      }
      return noErrors(this.errorLabels);
    },
    addressChanged: function addressChanged(event) {
      this.baseModel.id_address = 0;
      this.$emit("change", event);
    },
    generateStatesList: function generateStatesList() {
      var _this$baseModel$count3;
      this.displayedListStates = [];
      if ((_this$baseModel$count3 = this.baseModel.country) !== null && _this$baseModel$count3 !== void 0 && _this$baseModel$count3.id_country) {
        for (var state in this.listStates) {
          if (this.listStates[state].id_country === this.baseModel.country.id_country) {
            this.displayedListStates.push(this.listStates[state]);
          }
        }
      }
    },
    loadAddressSuggestions: function loadAddressSuggestions(query) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loadingAddressSuggestions = true;
              _context.next = 3;
              return fetchAddressSuggestions(query);
            case 3:
              _this.addressSuggestions = _context.sent;
              _this.loadingAddressSuggestions = false;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onAddressSelected: function onAddressSelected(selectedValue) {
      var _this2 = this;
      if (typeof selectedValue === "string") {
        this.addressChanged(selectedValue);
        return;
      }
      if (selectedValue && _typeof(selectedValue) === "object" && selectedValue.context) {
        var addressData = parseAddressFromMapbox(selectedValue, this.listCountries, []);
        if (addressData) {
          this.baseModel.street = addressData.street;
          if (addressData.zip) this.baseModel.zip = addressData.zip;
          if (addressData.city) this.baseModel.city = addressData.city;
          if (addressData.country) {
            this.baseModel.country = addressData.country;
            this.generateStatesList();
            this.$nextTick(function () {
              var addressDataWithState = parseAddressFromMapbox(selectedValue, _this2.listCountries, _this2.displayedListStates);
              if (addressDataWithState && addressDataWithState.state) {
                _this2.baseModel.state = addressDataWithState.state;
              } else {
                _this2.baseModel.state = {
                  id_state: null
                };
              }
            });
          } else {
            this.baseModel.country = null;
          }
        }
        this.addressChanged(selectedValue);
      }
    },
    useCurrentLocation: function useCurrentLocation() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var currentAddress;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this3.disabled || _this3.loadingCurrentLocation)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _this3.loadingCurrentLocation = true;
              _context2.prev = 3;
              _context2.next = 6;
              return getCurrentPositionAddress();
            case 6:
              currentAddress = _context2.sent;
              _this3.onAddressSelected(currentAddress);
              _context2.next = 14;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);
              console.error("Error getting current location:", _context2.t0);
              _this3.$toasted.show(_context2.t0.message === "User denied Geolocation" ? "Location permission denied" : "Unable to get your current location", {
                type: "error"
              });
            case 14:
              _context2.prev = 14;
              _this3.loadingCurrentLocation = false;
              return _context2.finish(14);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 10, 14, 17]]);
      }))();
    }
  },
  watch: {
    "baseModel.country.id_country": function baseModelCountryId_country(newVal, oldVal) {
      this.generateStatesList();
      //We reset state to null when country changed
      if (oldVal !== undefined && this.baseModel.state != null && this.baseModel.id_address == 0) {
        this.baseModel.state = {
          id_state: null
        };
      }
    },
    //IN CASE listStates is generated after id_country is retrieved
    listStates: function listStates(newVal, oldVal) {
      this.generateStatesList();
    },
    searchInput: function searchInput(newVal) {
      var _this4 = this;
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(function () {
        if (newVal) {
          _this4.loadAddressSuggestions(newVal);
        }
      }, 300);
    }
  }
};